import { StateValue } from 'xstate';

export function stateHasExactPath(value: StateValue, path: string): boolean {
  return path.split('.').reduce(
    ({ pred, substate }, part) => {
      return typeof substate === 'object'
        ? { pred: pred && part in substate, substate: substate[part] ?? {} }
        : { pred: pred && substate === part, substate: {} };
    },
    { pred: true, substate: value },
  ).pred;
}
